import { IDashboardRepository } from '../../domain/repositories/IDashboardRepository';
import { CourseDTO } from '../dto/CourseDTO';
import { CourseMapper } from '../mappers/CourseMapper';

/**
 * Get Courses Use Case
 * Retrieves courses for a student
 */
export class GetCoursesUseCase {
  constructor(private dashboardRepository: IDashboardRepository) {}

  async execute(): Promise<CourseDTO[]> {
    console.log('GetCoursesUseCase: Starting execute...');
    try {
      console.log('GetCoursesUseCase: Calling repository.getCourses()...');
      const courses = await this.dashboardRepository.getCourses();
      console.log('GetCoursesUseCase: Courses fetched from repository:', courses);

      const courseDTOs = CourseMapper.toDTOList(courses);
      console.log('GetCoursesUseCase: Courses mapped to DTOs:', courseDTOs);

      return courseDTOs;
    } catch (error) {
      console.error('GetCoursesUseCase: Error executing:', error);
      throw error;
    }
  }
}
